import React from "react";
import { Box, Typography, Button } from "@mui/material";
import styles from "./sectionSwitcher.module.scss";

interface Section {
  label: string;
  value: number;
  icon: string;
}

interface SectionSwitcherProps {
  sections: Section[];
  activeSection: number;
  onChange: (value: number) => void;
}

const SectionSwitcher: React.FC<SectionSwitcherProps> = ({
  sections,
  activeSection,
  onChange,
}) => {
  return (
    <Box className={styles.container}>
      <Typography className={styles.label}>Sections:</Typography>
      <Box className={styles.sectionsGroup}>
        {sections.map((section) => (
          <Button
            key={section.value}
            className={`${styles.sectionButton} ${
              activeSection === section.value ? styles.active : ""
            }`}
            onClick={() => onChange(section.value)}
            startIcon={
              <img
                src={section.icon}
                alt={section.label}
                style={{ width: 18, height: 18, filter:
                  activeSection === section.value
                    ? "brightness(0) invert(1)" 
                    : "none", }}
              />
            }
          >
            {section.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default SectionSwitcher;
